import {
  defaultTheme_default,
  init_defaultTheme,
  init_esm2 as init_esm,
  useTheme_default
} from "./chunk-LXPIB7J4.js";
import {
  require_react
} from "./chunk-KJIRP3BF.js";
import {
  __toESM
} from "./chunk-J43GMYXM.js";

// node_modules/.pnpm/@mui+material@5.10.8_af5ln35zuaotaffazii6n6bke4/node_modules/@mui/material/esm/styles/useTheme.js
var React = __toESM(require_react());
init_esm();
init_defaultTheme();
function useTheme() {
  const theme = useTheme_default(defaultTheme_default);
  if (__vite_process_env_NODE_ENV !== "production") {
    React.useDebugValue(theme);
  }
  return theme;
}

export {
  useTheme
};
//# sourceMappingURL=chunk-PRPF77W2.js.map
